module.exports = __webpack_public_path__ + "img/12_klio_06.c9f89744.jpg";